export enum VCSReferenceType {
    Branch = 'branch',
    Commit = 'commit',
    Tag = 'tag',
}